// extracted by mini-css-extract-plugin
export default {"badge":"TableDeals_badge__3lNw4","tabs":"TableDeals_tabs__h3S6p"};